import { render, staticRenderFns } from "./NextBlock.vue?vue&type=template&id=8f0ed00c&lang=pug&"
import script from "./NextBlock.vue?vue&type=script&lang=js&"
export * from "./NextBlock.vue?vue&type=script&lang=js&"
import style0 from "./NextBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports